import { render, staticRenderFns } from "./ContactSecurityRoleEdit.vue?vue&type=template&id=34d2ef4e&"
import script from "./ContactSecurityRoleEdit.vue?vue&type=script&lang=js&"
export * from "./ContactSecurityRoleEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports